import React, { lazy, Suspense, useState, useEffect } from 'react';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Loader from './component/Loader/Loader';
import NavMotion from './layout/NavMotion';
import MainLayout from './layout/MainLayout';
import MinimalLayout from './layout/MinimalLayout';

const AuthLogin = lazy(() => import('./views/Login'));
const Register_Partner = lazy(() => import('./views/Login/Register_Partner'));
const Googleauthenticator = lazy(() => import('./views/Login/Googleauthenticator'));
const LoginEmailVerify = lazy(() => import('./views/Login/LoginEmailVerify'));
const Select_Order = lazy(() => import('./views/Dashboard_New/Select_Order'));
const Deposit_Form = lazy(() => import('./views/Dashboard_New/Deposit_Form'));
// const Deposit_Print = lazy(() => import('./views/Dashboard_New/Deposit_Print'));
const Withdrawal_Form = lazy(() => import('./views/Dashboard_New/Withdrawal_Form'));
const Withdrawal_Print = lazy(() => import('./views/Dashboard_New/Withdrawal_Print'));
const Completeregistration = lazy(() => import('./views/Dashboard_New/Completeregistration'));
const Deposit_Print = lazy(() => import('./views/Dashboard_New/Cash_Order_Form'));
const Cash_Order = lazy(() => import('./views/Dashboard_New/Cash_Order'));

const Withdrawal_Transactions = lazy(() => import('./views/Transactions/Withdrawal_Transactions'));
const Withdrawal_Invoice = lazy(() => import('./views/Transactions/Withdrawal_Invoice'));
const Withdrawal_Invoices = lazy(() => import('./views/Transactions/Withdrawal_Invoices'));
const Withdrawal_Invoice_Details = lazy(() => import('./views/Transactions/Withdrawal_Invoice_Details'));
const Deposit_Transactions = lazy(() => import('./views/Transactions/Deposit_Transactions'));

const AuthForgetpassword = lazy(() => import('./views/Forgetpassword'));
const ForgetChangePassword = lazy(() => import('./views/Forgetpassword/ForgetChangePassword'));
const Otp = lazy(() => import('./views/Otp'));
const Editprofile = lazy(() => import('./views/Profile/Editprofile'));
const Change_Password = lazy(() => import('./views/Profile/Change_Password'));
const Bank_Details = lazy(() => import('./views/Profile/Bank_Details'));
const TwoSecurity = lazy(() => import('./views/Profile/TwoSecurity'));
const Maintain = lazy(() => import('./views/Error/Maintain'));

const DashboardDefault = lazy(() => import('./views/Dashboard/Default'));
const Create_Button = lazy(() => import('./views/Dashboard_New/Create_Button'));
const Create_Second_Widget = lazy(() => import('./views/Dashboard_New/Create_Second_Widget'));
const Dashboard_new = lazy(() => import('./views/Dashboard_New/Dashboard_new'));
const Dashboard_voucher = lazy(() => import('./views/Dashboard_New/Dashboard_voucher'));
const RtlLayout = lazy(() => import('./views/RtlLayout'));
const TableBasic = lazy(() => import('./views/Tables/TableBasic'));
const UtilsIcons = lazy(() => import('./views/Utils/Icons'));
const UtilsTypography = lazy(() => import('./views/Utils/Typography'));
const MultiLanguage = lazy(() => import('./views/MultiLanguage'));
const PrepaidCardList = lazy(() => import('./views/PrepaidCard/PrepaidCardList'));
const SellerPrepaidCardList = lazy(() => import('./views/PrepaidCard/SellerPrepaidCardList'));
const UserPrepaidCardList = lazy(() => import('./views/PrepaidCard/UserPrepaidCardList'));
const EditPrepaidCardList = lazy(() => import('./views/PrepaidCard/EditPrepaidCardList'));
const EditPrepaidCardDashboard = lazy(() => import('./views/PrepaidCard/EditPrepaidCardDashboard'));
const EditUserPrepaidCardList = lazy(() => import('./views/PrepaidCard/EditUserPrepaidCardList'));
const EditSellerPrepaidCardList = lazy(() => import('./views/PrepaidCard/EditSellerPrepaidCardList'));
const SellerList = lazy(() => import('./views/Accounts/SellerList'));
const AddSeller = lazy(() => import('./views/Accounts/AddSeller'));
const AddSecondPartner = lazy(() => import('./views/Accounts/AddSecondPartner'));
const UpdateSeller = lazy(() => import('./views/Accounts/UpdateSeller'));
const SellersUsersList = lazy(() => import('./views/Accounts/SellersUsers'));
const AddSellersUser = lazy(() => import('./views/Accounts/AddSellersUser'));
const UpdateSellersUser = lazy(() => import('./views/Accounts/UpdateSellersUser'));

const Profit_Invoice = lazy(() => import('./views/Voucher_Billing/Profit_Invoice'));
const Profit_Invoice_Gen = lazy(() => import('./views/Voucher_Billing/Profit_Invoice_generate'));
const Settlement = lazy(() => import('./views/Voucher_Billing/Settlement'));
const VoucherPartnerSettlementWithdrawalInvoice = lazy(() => import('./views/Voucher_Billing/VoucherPartnerSettlementWithdrawalInvoice'));
const VoucherSellerSettlementWithdrawalInvoice = lazy(() => import('./views/Voucher_Billing/VoucherSellerSettlementWithdrawalInvoice'));

const Routes = () => {
    const location = useLocation();
    const [auth, set_auth] = useState(true);


    useEffect(() => {
        if (window.localStorage.getItem("temp_u_id") !== null) {
            set_auth(false);
        }
    }, [])

    return (
        <AnimatePresence>
            <Suspense fallback={<Loader />}>
                <Switch>
                    
                    <Route exact path="/" component={AuthLogin} />
                    <Route exact path="/login" component={AuthLogin} />
                    <Route exact path="/register-partner" component={Register_Partner} />
                    <Route exact path="/googleauthenticator" component={Googleauthenticator} />
                    <Route exact path="/loginemailverify" component={LoginEmailVerify} />
                    <Route exact path="/select_order/:token" component={Select_Order} />
                    <Route exact path="/select_order" component={Select_Order} />
                    <Route exact path="/Deposit_Form" component={Deposit_Form} />
                    {/* <Route exact path="/Deposit_Print/:token" component={Deposit_Print} />
                    <Route exact path="/Deposit_Print" component={Deposit_Print} /> */}
                    <Route exact path="/Withdrawal_Form/:token" component={Withdrawal_Form} />
                    <Route exact path="/Withdrawal_Form" component={Withdrawal_Form} />
                    <Route exact path="/Completeregistration" component={Completeregistration} />
                    <Route exact path="/Withdrawal_Print/:id" component={Withdrawal_Print} />
                    <Route exact path="/Withdrawal_Print" component={Withdrawal_Print} />
                    <Route exact path="/forgetpassword" component={AuthForgetpassword} />
                    <Route exact path="/create-password/:token" component={ForgetChangePassword} />
                    <Route exact path="/create-password" component={ForgetChangePassword} />
                    <Route exact path="/otp" component={Otp} />
                    <Route exact path="/Deposit_Print/:token" component={Deposit_Print} />
                    <Route exact path="/Deposit_Print" component={Deposit_Print} />
                    <Route exact path="/Cash_Order/:id" component={Cash_Order} />
                    <Route exact path="/Cash_Order" component={Cash_Order} />
                    
                    <Route path={[]}>
                        <MinimalLayout>
                            <Switch location={location} key={location.pathname}>
                                <NavMotion></NavMotion>
                            </Switch>
                        </MinimalLayout>
                    </Route>
                    

                    { auth ?
                    <MainLayout>
                        <Switch location={location} key={location.pathname}>
                            <NavMotion>

                                <Route exact path="/Dashboard_new" component={DashboardDefault} />
                                <Route exact path="/Withdrawal_Transactions" component={Withdrawal_Transactions} />
                                <Route exact path="/Editprofile" component={Editprofile} />
                                <Route exact path="/Change_Password" component={Change_Password} /> 
                                <Route exact path="/Bank_Details" component={Bank_Details} />  
                                <Route exact path="/TwoSecurity" component={TwoSecurity} />
                                <Route exact path="/Dashboard_new" component={Dashboard_new} />
                                <Route exact path="/Dashboard_voucher" component={Dashboard_voucher} />
                                <Route exact path="/Create_Button" component={Create_Button} />
                                <Route exact path="/Create_Second_Widget" component={Create_Second_Widget} />  
                                <Route exact path="/Withdrawal_Invoice/:my" component={Withdrawal_Invoice} />
                                <Route exact path="/Withdrawal_Invoice" component={Withdrawal_Invoice} />
                                <Route exact path="/Withdrawal_Invoices" component={Withdrawal_Invoices} />
                                <Route exact path="/Withdrawal_Invoice_Details/:id" component={Withdrawal_Invoice_Details} />
                                <Route exact path="/Deposit_Transactions" component={Deposit_Transactions} />

                                <Route exact path="/maintenance" component={Maintain} /> 

                                <Route path="/utils/util-typography" component={UtilsTypography} />
                                <Route path="/multi-language" component={MultiLanguage} />
                                <Route path="/rtl" component={RtlLayout} />
                                <Route path="/utils/util-icons" component={UtilsIcons} />
                                <Route path="/tables/table-basic" component={TableBasic} />
                                <Route exact path="/PrepaidCardList" component={PrepaidCardList} />
                                <Route path="/SellerPrepaidCardList/:id" component={SellerPrepaidCardList} />
                                <Route path="/UserPrepaidCardList/:id" component={UserPrepaidCardList} />
                                <Route path="/PrepaidCardList/:id" component={PrepaidCardList} />
                                <Route path="/EditPrepaidCardList/:id" component={EditPrepaidCardList} />
                                <Route path="/SellerList" component={SellerList} />
                                <Route path="/AddSeller" component={AddSeller} />
                                <Route path="/UpdateSeller/:id" component={UpdateSeller} />
                                <Route path="/SellersUsersList" component={SellersUsersList} />
                                <Route path="/AddSellersUser" component={AddSellersUser} />
                                <Route path="/UpdateSellersUser/:id" component={UpdateSellersUser} />

                                {/* new for partner panel */}
                                <Route exact path="/Profit_Invoice" component={Profit_Invoice} />
                                <Route exact path="/Settlement" component={Settlement} />
                                <Route exact path="/voucher-partner-settlement-withdrawal-invoice/:id" component={VoucherPartnerSettlementWithdrawalInvoice} />
                                <Route exact path="/voucher-seller-settlement-withdrawal-invoice/:id" component={VoucherSellerSettlementWithdrawalInvoice} />

                                <Route path="/EditUserPrepaidCardList/:id/:subadmin" component={EditUserPrepaidCardList} />

                                <Route path="/EditSellerPrepaidCardList/:id/:subadmin" component={EditSellerPrepaidCardList} />
                                <Route exact path="/Profit_Invoice_Gen/:id" component={Profit_Invoice_Gen} />
                                <Route path="/AddSecondPartner" component={AddSecondPartner} />
                                <Route path="/EditPrepaidCardDashboard/:id" component={EditPrepaidCardDashboard} />


                            </NavMotion>
                        </Switch>
                    </MainLayout>
                    : 
                        <Redirect to='/login' />
                    }

                </Switch>
            </Suspense>
        </AnimatePresence>
    );
};

export default Routes;
